// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the three app-distribution surfaces: the /app page
   (GetTheAppPage), the mobile web banner (InstallAppBanner) and the in-app
   update notice (AppUpdateNotice).

   Palette note, because it is easy to get backwards here: the download button
   is BLUE, not orange. Orange is reserved for primary *commercial* actions --
   Add to Cart, checkout, discount pills -- and installing an app is not one.
   Blue is the token system's "secondary interaction / information" role, which
   is exactly what this is. Both fills use --color-secondary rather than
   --color-brand-blue, because white text only clears AA on the mixed role
   token (4.75:1); on raw #3B82F6 it is 3.68:1 and fails.

   The hero is navy in BOTH themes, so its text uses --color-on-navy* rather
   than --text-*, which flips to navy in light mode and would disappear. */

/* ── /app page ──────────────────────────────────────────────────────────── */

.gta-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 var(--space-3, 16px) var(--space-6, 48px);
}

.gta-hero {
  background: var(--color-brand-navy);
  border-radius: var(--radius-lg);
  padding: 32px 24px;
  text-align: center;
  margin-bottom: 24px;
}

.gta-hero-mark {
  width: 60px;
  height: 60px;
  margin: 0 auto 14px;
  border-radius: var(--radius-md);
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.1);
  color: var(--color-on-navy);
}

.gta-hero-title {
  margin: 0 0 8px;
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-on-navy);
}

.gta-hero-sub {
  margin: 0 auto;
  max-width: 46ch;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--color-on-navy-secondary);
}

.gta-installed {
  margin: 16px auto 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: var(--radius-pill);
  background: rgba(255, 255, 255, 0.12);
  color: var(--color-on-navy);
  font-size: 0.85rem;
  font-weight: 600;
}

/* The two install routes, side by side on anything wider than a phone. */
.gta-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

@media (max-width: 700px) {
  .gta-options { grid-template-columns: minmax(0, 1fr); }
}

.gta-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
}

/* The route this particular device can actually use is the one outlined. It is
   a border rather than a fill so the two cards stay equally readable -- the
   other route is still perfectly valid, just not the obvious one here. */
.gta-option.is-primary {
  border-color: var(--color-secondary);
  box-shadow: var(--shadow-sm);
}

.gta-option-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.gta-option-badge {
  padding: 3px 9px;
  border-radius: var(--radius-pill);
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.gta-option-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.gta-option-body {
  margin: 0 0 16px;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.gta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;           /* a real touch target */
  padding: 0 20px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s, border-color 0.15s;
}

.gta-btn-primary {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

.gta-btn-primary:hover { background: var(--color-secondary-hover); }

.gta-btn-secondary {
  background: transparent;
  border-color: var(--color-secondary);
  color: var(--color-secondary-text);
}

.gta-btn-secondary:hover { background: var(--color-secondary-soft); }

.gta-meta {
  margin: 10px 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
}

/* Advisory line. Orange lives in the ICON only -- orange body text on a light
   surface is 2.92:1 and cannot reach AA at any size -- so the label stays at
   normal text colour and the hue is carried by the glyph beside it. */
.gta-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.gta-note svg {
  flex: none;
  margin-top: 2px;
  color: var(--color-brand-orange);
}

.gta-ios-steps {
  margin: 4px 0 0;
  padding-left: 20px;
  font-size: 0.88rem;
  line-height: 1.6;
  color: var(--text-secondary);
}

/* ── Sections ───────────────────────────────────────────────────────────── */

.gta-section {
  padding: 22px;
  margin-bottom: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
}

.gta-section-title {
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
}

.gta-section-lead {
  margin: 0 0 18px;
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.gta-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 16px;
}

.gta-step {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  min-width: 0;
}

.gta-step-num {
  flex: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.8rem;
  font-weight: 700;
}

.gta-step-title {
  margin: 0 0 3px;
  font-size: 0.95rem;
  font-weight: 650;
  color: var(--text-primary);
}

.gta-step-body {
  margin: 0;
  font-size: 0.87rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.gta-trust {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 20px 0 0;
  padding: 14px;
  border-radius: var(--radius-sm);
  background: var(--color-secondary-soft);
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.gta-trust svg {
  flex: none;
  margin-top: 1px;
  color: var(--color-secondary-text);
}

.gta-benefits {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 700px) {
  .gta-benefits { grid-template-columns: minmax(0, 1fr); }
}

.gta-benefit { min-width: 0; }

.gta-benefit-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  margin-bottom: 10px;
  border-radius: var(--radius-sm);
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
}

.gta-benefit-title {
  margin: 0 0 4px;
  font-size: 0.93rem;
  font-weight: 650;
  color: var(--text-primary);
}

.gta-benefit-body {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.gta-update-note {
  margin: 0;
  padding: 0 4px;
  font-size: 0.8rem;
  line-height: 1.5;
  text-align: center;
  color: var(--text-muted);
}

/* ── Mobile web install banner ──────────────────────────────────────────── */

/* Top of the viewport, floating over the page -- the shape news sites use for
   this, and the one the browser's own install infobar occupies. It covers the
   site header while shown, which is the trade this pattern makes: the offer is
   transient, appears once, and is dismissed for 30 days after any interaction.

   z-index 210 puts it above the sticky site header (100) and the bottom nav
   (200). Nothing else in the app sits higher except modals, which is correct --
   a dialog must never end up underneath this. */
.pwa-install {
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 8px);
  left: 8px;
  right: 8px;
  z-index: 210;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: var(--radius-md);
  background: var(--color-brand-navy);
  box-shadow: var(--shadow-md);
  animation: pwa-install-in 260ms ease-out both;
}

/* Slides down from behind the top edge rather than fading in place, so it
   reads as arriving over the page instead of as part of it. */
@keyframes pwa-install-in {
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Circular, on white -- an app icon, which is what is being installed. The
   logo artwork is orange and navy on transparent, so it needs a light disc
   behind it to read at all on the navy card. */
.pwa-install-icon {
  flex: none;
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--color-brand-white);
  overflow: hidden;
}

.pwa-install-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;          /* lets the text ellipsis instead of pushing the CTA off */
  flex: 1 1;
}

/* --color-on-navy, not --text-primary. The card is navy in BOTH themes, and
   --text-* flips to navy in light mode -- which would put navy text on a navy
   card and make this invisible for most visitors. */
.pwa-install-title {
  font-size: 0.98rem;
  font-weight: 650;
  line-height: 1.25;
  color: var(--color-on-navy);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pwa-install-origin {
  font-size: 0.8rem;
  line-height: 1.3;
  color: var(--color-on-navy-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Plain blue text, not a filled button. On this navy the pure brand blue is
   about 5:1, so it clears AA as normal-size text -- the mixed --color-secondary
   is for fills carrying white, and is needlessly dark here.

   Blue rather than orange on purpose: orange is reserved for commercial actions
   (Add to Cart, checkout). Installing an app is not one, and an orange Install
   would compete with the buy button on the page behind it. */
.pwa-install-cta {
  flex: none;
  display: inline-flex;
  align-items: center;
  min-height: 44px;      /* full touch target even though it looks like text */
  padding: 0 6px;
  border: none;
  background: transparent;
  color: var(--color-brand-blue);
  font: inherit;
  font-size: 0.98rem;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
}

.pwa-install-cta:disabled { opacity: 0.6; cursor: default; }

.pwa-install-close {
  flex: none;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--color-on-navy-muted);
  cursor: pointer;
}

.pwa-install-close:hover { color: var(--color-on-navy); }

.pwa-install-cta:focus-visible,
.pwa-install-close:focus-visible {
  outline: 2px solid var(--color-brand-blue);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .pwa-install { animation: none; }
}

/* ── In-app update notice ───────────────────────────────────────────────── */

.app-update-bar {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 8px);
  z-index: 190;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  background: var(--color-brand-navy);
  box-shadow: var(--shadow-md);
}

.app-update-bar-text {
  flex: 1 1;
  min-width: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-on-navy);
}

.app-update-bar-cta {
  flex: none;
  min-height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.85rem;
  font-weight: 650;
  cursor: pointer;
}

.app-update-bar-close {
  flex: none;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: var(--radius-xs);
  background: transparent;
  color: var(--color-on-navy-muted);
  cursor: pointer;
}

/* The mandatory variant. Covers everything and offers no way past, so it is
   only ever reached when the server says this build is below
   minSupportedVersionCode. */
.app-update-block {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--color-brand-navy);
}

.app-update-block-card {
  max-width: 380px;
  text-align: center;
}

.app-update-block-icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: var(--color-brand-orange);
}

.app-update-block-title {
  margin: 0 0 10px;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-on-navy);
}

.app-update-block-body {
  margin: 0 0 22px;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--color-on-navy-secondary);
}

.app-update-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 24px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-size: 0.95rem;
  font-weight: 650;
  cursor: pointer;
}

.app-update-notes {
  margin: 16px 0 0;
  font-size: 0.82rem;
  line-height: 1.5;
  color: var(--color-on-navy-muted);
}

/* ── Update offer ──────────────────────────────────────────────────────────
   The same strip as .pwa-install, in the same place, with one thing changed:
   the icon is a refresh mark on brand blue rather than the app logo on white.
   That is the whole distinction -- install offers you the app, this offers you
   a newer copy of the app you already have -- and it is deliberately small,
   because a shopkeeper should recognise the shape without reading it twice.

   Blue, not orange: orange is this palette's commercial colour (Add to Cart,
   checkout, discounts). Updating is an interaction, which is blue's role. */
.pwa-update-icon {
  background: color-mix(in srgb, var(--color-brand-blue) 18%, var(--color-brand-navy));
  color: var(--color-brand-white);
  /* The install icon is 48px because it holds a logo. A 22px glyph in that
     much space floats; this sizes the disc to the mark it carries. */
  width: 40px;
  height: 40px;
}

/* Wider than .pwa-install, which is phone-only. The admin dashboard is used on
   a laptop, and a stale build matters just as much there -- so this one is
   capped and centred instead of running the full width of a desktop screen. */
@media (min-width: 701px) {
  .pwa-update {
    left: auto;
    right: 16px;
    max-width: 420px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/GetTheApp.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;0EAa0E;;AAE1E,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe,qCAAqC,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;yEAEyE;AACzE;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;EACvC,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB,YAAY,wBAAwB;EACpD,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,yBAAyB,wCAAwC,EAAE;;AAEnE;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,2BAA2B,uCAAuC,EAAE;;AAEpE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;sEAEsE;AACtE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gBAAgB,qCAAqC,EAAE;AACzD;;AAEA,eAAe,YAAY,EAAE;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,8EAA8E;;AAE9E;;;;;;;gDAOgD;AAChD;EACE,eAAe;EACf,8CAA8C;EAC9C,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;8DAC8D;AAC9D;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;+CAE+C;AAC/C;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY,WAAW,0DAA0D;EACjF,SAAO;AACT;;AAEA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;6DAM6D;AAC7D;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB,OAAO,qDAAqD;EAC5E,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,4BAA4B,YAAY,EAAE,eAAe,EAAE;;AAE3D;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA,2BAA2B,2BAA2B,EAAE;;AAExD;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe,eAAe,EAAE;AAClC;;AAEA,8EAA8E;;AAE9E;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,2DAA2D;EAC3D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;6BAE6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;;;;;;4EAQ4E;AAC5E;EACE,oFAAoF;EACpF,+BAA+B;EAC/B;qEACmE;EACnE,WAAW;EACX,YAAY;AACd;;AAEA;;8EAE8E;AAC9E;EACE;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* Styles for the three app-distribution surfaces: the /app page\n   (GetTheAppPage), the mobile web banner (InstallAppBanner) and the in-app\n   update notice (AppUpdateNotice).\n\n   Palette note, because it is easy to get backwards here: the download button\n   is BLUE, not orange. Orange is reserved for primary *commercial* actions --\n   Add to Cart, checkout, discount pills -- and installing an app is not one.\n   Blue is the token system's \"secondary interaction / information\" role, which\n   is exactly what this is. Both fills use --color-secondary rather than\n   --color-brand-blue, because white text only clears AA on the mixed role\n   token (4.75:1); on raw #3B82F6 it is 3.68:1 and fails.\n\n   The hero is navy in BOTH themes, so its text uses --color-on-navy* rather\n   than --text-*, which flips to navy in light mode and would disappear. */\n\n/* ── /app page ──────────────────────────────────────────────────────────── */\n\n.gta-page {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 0 var(--space-3, 16px) var(--space-6, 48px);\n}\n\n.gta-hero {\n  background: var(--color-brand-navy);\n  border-radius: var(--radius-lg);\n  padding: 32px 24px;\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.gta-hero-mark {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 14px;\n  border-radius: var(--radius-md);\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--color-on-navy);\n}\n\n.gta-hero-title {\n  margin: 0 0 8px;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--color-on-navy);\n}\n\n.gta-hero-sub {\n  margin: 0 auto;\n  max-width: 46ch;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--color-on-navy-secondary);\n}\n\n.gta-installed {\n  margin: 16px auto 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border-radius: var(--radius-pill);\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--color-on-navy);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n/* The two install routes, side by side on anything wider than a phone. */\n.gta-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 28px;\n}\n\n@media (max-width: 700px) {\n  .gta-options { grid-template-columns: minmax(0, 1fr); }\n}\n\n.gta-option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n  padding: 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n}\n\n/* The route this particular device can actually use is the one outlined. It is\n   a border rather than a fill so the two cards stay equally readable -- the\n   other route is still perfectly valid, just not the obvious one here. */\n.gta-option.is-primary {\n  border-color: var(--color-secondary);\n  box-shadow: var(--shadow-sm);\n}\n\n.gta-option-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.gta-option-badge {\n  padding: 3px 9px;\n  border-radius: var(--radius-pill);\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.gta-option-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.gta-option-body {\n  margin: 0 0 16px;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.gta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;           /* a real touch target */\n  padding: 0 20px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.gta-btn-primary {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\n.gta-btn-primary:hover { background: var(--color-secondary-hover); }\n\n.gta-btn-secondary {\n  background: transparent;\n  border-color: var(--color-secondary);\n  color: var(--color-secondary-text);\n}\n\n.gta-btn-secondary:hover { background: var(--color-secondary-soft); }\n\n.gta-meta {\n  margin: 10px 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n/* Advisory line. Orange lives in the ICON only -- orange body text on a light\n   surface is 2.92:1 and cannot reach AA at any size -- so the label stays at\n   normal text colour and the hue is carried by the glyph beside it. */\n.gta-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 12px 0 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.gta-note svg {\n  flex: none;\n  margin-top: 2px;\n  color: var(--color-brand-orange);\n}\n\n.gta-ios-steps {\n  margin: 4px 0 0;\n  padding-left: 20px;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n/* ── Sections ───────────────────────────────────────────────────────────── */\n\n.gta-section {\n  padding: 22px;\n  margin-bottom: 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n}\n\n.gta-section-title {\n  margin: 0 0 8px;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.gta-section-lead {\n  margin: 0 0 18px;\n  font-size: 0.9rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.gta-steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 16px;\n}\n\n.gta-step {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.gta-step-num {\n  flex: none;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.gta-step-title {\n  margin: 0 0 3px;\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.gta-step-body {\n  margin: 0;\n  font-size: 0.87rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.gta-trust {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 20px 0 0;\n  padding: 14px;\n  border-radius: var(--radius-sm);\n  background: var(--color-secondary-soft);\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.gta-trust svg {\n  flex: none;\n  margin-top: 1px;\n  color: var(--color-secondary-text);\n}\n\n.gta-benefits {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n@media (max-width: 700px) {\n  .gta-benefits { grid-template-columns: minmax(0, 1fr); }\n}\n\n.gta-benefit { min-width: 0; }\n\n.gta-benefit-icon {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  margin-bottom: 10px;\n  border-radius: var(--radius-sm);\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n}\n\n.gta-benefit-title {\n  margin: 0 0 4px;\n  font-size: 0.93rem;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.gta-benefit-body {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.gta-update-note {\n  margin: 0;\n  padding: 0 4px;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n/* ── Mobile web install banner ──────────────────────────────────────────── */\n\n/* Top of the viewport, floating over the page -- the shape news sites use for\n   this, and the one the browser's own install infobar occupies. It covers the\n   site header while shown, which is the trade this pattern makes: the offer is\n   transient, appears once, and is dismissed for 30 days after any interaction.\n\n   z-index 210 puts it above the sticky site header (100) and the bottom nav\n   (200). Nothing else in the app sits higher except modals, which is correct --\n   a dialog must never end up underneath this. */\n.pwa-install {\n  position: fixed;\n  top: calc(env(safe-area-inset-top, 0px) + 8px);\n  left: 8px;\n  right: 8px;\n  z-index: 210;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border-radius: var(--radius-md);\n  background: var(--color-brand-navy);\n  box-shadow: var(--shadow-md);\n  animation: pwa-install-in 260ms ease-out both;\n}\n\n/* Slides down from behind the top edge rather than fading in place, so it\n   reads as arriving over the page instead of as part of it. */\n@keyframes pwa-install-in {\n  from { opacity: 0; transform: translateY(-12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Circular, on white -- an app icon, which is what is being installed. The\n   logo artwork is orange and navy on transparent, so it needs a light disc\n   behind it to read at all on the navy card. */\n.pwa-install-icon {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--color-brand-white);\n  overflow: hidden;\n}\n\n.pwa-install-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;          /* lets the text ellipsis instead of pushing the CTA off */\n  flex: 1;\n}\n\n/* --color-on-navy, not --text-primary. The card is navy in BOTH themes, and\n   --text-* flips to navy in light mode -- which would put navy text on a navy\n   card and make this invisible for most visitors. */\n.pwa-install-title {\n  font-size: 0.98rem;\n  font-weight: 650;\n  line-height: 1.25;\n  color: var(--color-on-navy);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pwa-install-origin {\n  font-size: 0.8rem;\n  line-height: 1.3;\n  color: var(--color-on-navy-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Plain blue text, not a filled button. On this navy the pure brand blue is\n   about 5:1, so it clears AA as normal-size text -- the mixed --color-secondary\n   is for fills carrying white, and is needlessly dark here.\n\n   Blue rather than orange on purpose: orange is reserved for commercial actions\n   (Add to Cart, checkout). Installing an app is not one, and an orange Install\n   would compete with the buy button on the page behind it. */\n.pwa-install-cta {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;      /* full touch target even though it looks like text */\n  padding: 0 6px;\n  border: none;\n  background: transparent;\n  color: var(--color-brand-blue);\n  font: inherit;\n  font-size: 0.98rem;\n  font-weight: 650;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.pwa-install-cta:disabled { opacity: 0.6; cursor: default; }\n\n.pwa-install-close {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--color-on-navy-muted);\n  cursor: pointer;\n}\n\n.pwa-install-close:hover { color: var(--color-on-navy); }\n\n.pwa-install-cta:focus-visible,\n.pwa-install-close:focus-visible {\n  outline: 2px solid var(--color-brand-blue);\n  outline-offset: 2px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pwa-install { animation: none; }\n}\n\n/* ── In-app update notice ───────────────────────────────────────────────── */\n\n.app-update-bar {\n  position: fixed;\n  left: 8px;\n  right: 8px;\n  bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 8px);\n  z-index: 190;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--radius-md);\n  background: var(--color-brand-navy);\n  box-shadow: var(--shadow-md);\n}\n\n.app-update-bar-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-on-navy);\n}\n\n.app-update-bar-cta {\n  flex: none;\n  min-height: 34px;\n  padding: 0 14px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.85rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.app-update-bar-close {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: var(--radius-xs);\n  background: transparent;\n  color: var(--color-on-navy-muted);\n  cursor: pointer;\n}\n\n/* The mandatory variant. Covers everything and offers no way past, so it is\n   only ever reached when the server says this build is below\n   minSupportedVersionCode. */\n.app-update-block {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: var(--color-brand-navy);\n}\n\n.app-update-block-card {\n  max-width: 380px;\n  text-align: center;\n}\n\n.app-update-block-icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 16px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--color-brand-orange);\n}\n\n.app-update-block-title {\n  margin: 0 0 10px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--color-on-navy);\n}\n\n.app-update-block-body {\n  margin: 0 0 22px;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: var(--color-on-navy-secondary);\n}\n\n.app-update-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 46px;\n  padding: 0 24px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-size: 0.95rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.app-update-notes {\n  margin: 16px 0 0;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  color: var(--color-on-navy-muted);\n}\n\n/* ── Update offer ──────────────────────────────────────────────────────────\n   The same strip as .pwa-install, in the same place, with one thing changed:\n   the icon is a refresh mark on brand blue rather than the app logo on white.\n   That is the whole distinction -- install offers you the app, this offers you\n   a newer copy of the app you already have -- and it is deliberately small,\n   because a shopkeeper should recognise the shape without reading it twice.\n\n   Blue, not orange: orange is this palette's commercial colour (Add to Cart,\n   checkout, discounts). Updating is an interaction, which is blue's role. */\n.pwa-update-icon {\n  background: color-mix(in srgb, var(--color-brand-blue) 18%, var(--color-brand-navy));\n  color: var(--color-brand-white);\n  /* The install icon is 48px because it holds a logo. A 22px glyph in that\n     much space floats; this sizes the disc to the mark it carries. */\n  width: 40px;\n  height: 40px;\n}\n\n/* Wider than .pwa-install, which is phone-only. The admin dashboard is used on\n   a laptop, and a stale build matters just as much there -- so this one is\n   capped and centred instead of running the full width of a desktop screen. */\n@media (min-width: 701px) {\n  .pwa-update {\n    left: auto;\n    right: 16px;\n    max-width: 420px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
